import React from 'react';
import { Grid, Typography } from '@mui/material';
import { goFrontPage, openShop } from '../../utils';

const width = window.innerWidth;
export default function Description({ classes, handler, navigate }) {
	return (
		<Grid className={classes.centerText}>
			<Grid onClick={openShop} className={classes.rightText} style={{ right: width > 992 ? 20 : 0 }}>
				<Typography className={classes.text}>Shop</Typography>
			</Grid>
			<Grid onClick={handler} className={classes.leftText} style={{ left: width > 992 ? 20 : 0 }}>
				<Typography className={classes.text}>I Never Read,</Typography>
			</Grid>
			<Grid onClick={() => goFrontPage(navigate)} className={classes.bottomText}>
				<Typography className={classes.text}>Digital</Typography>
			</Grid>
		</Grid>
	);
}
